import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { ReactNode, useCallback } from 'react';

type Props = {
  onCancel?: () => void;
  cancelBtnTxt?: string;
  submitBtnTxt?: string;
  submitBtnIcon?: ReactNode;
  cancelBtnIcon?: ReactNode;
  isLoading?: boolean;
  formId: string;
  disabled?: boolean;
};
const FormButtons = ({
  onCancel,
  cancelBtnTxt = 'Cancel',
  submitBtnTxt = 'Submit',
  submitBtnIcon = <SaveIcon />,
  cancelBtnIcon,
  isLoading = false,
  formId,
  disabled = false,
}: Props) => {
  const handleonCancel = useCallback(() => {
    if (onCancel) {
      onCancel();
    }
  }, [onCancel]);

  return (
    <div className="flex items-center gap-3">
      <Button color="secondary" variant="outlined" onClick={handleonCancel} startIcon={cancelBtnIcon ?? null}>
        {cancelBtnTxt}
      </Button>
      <LoadingButton
        loading={isLoading}
        loadingPosition="start"
        variant="contained"
        startIcon={submitBtnIcon}
        type="submit"
        form={formId}
        disabled={disabled}
      >
        {submitBtnTxt}
      </LoadingButton>
    </div>
  );
};

export default FormButtons;
